import { Fragment } from "react";

import { ProfileSchema }                          from "_common/schema";
import { ProfilePageTags }                        from "_common/seo";
import { initialValidations }                     from "_common/ssrWrapper";
import UserProfileNew                             from "_components/pages/userProfile";
import { fetchTabData }                           from "_components/pages/userProfile/utils";
import { getBroadcasterDetails, getUserSessions } from "_services/api/broadcast";
import { getSEOTags }                             from "_services/api/feed";
import { getUserProfile, getUserProfileStats }    from "_services/api/user";

import ErrorPage from "../_error";

const component = props => {
	const { userId, activeTab, activeTabData, seoTags } = props;

	if ( props?.error )
		return <ErrorPage msg = { props?.error?.displayMsg } />;

	const profile = props?.profile || {};

	const { name, followingGames } = profile;

	let selectedGames = "";

	if ( followingGames?.length ) {
		followingGames.forEach ( ( item, index ) => {
			if ( index === 0 )
				selectedGames += item.name;
			else
				selectedGames += "," + item.name;
		} );
	}

	const isNodwin = parseInt ( userId ) === 2053628975;

	return (
		<Fragment>

			<ProfileSchema
				followers = { profile?.follow?.followers }
				id = { profile?.id }
				image = { profile?.photo }
				name = { profile?.name }
			/>

			<ProfilePageTags
				desc = { isNodwin ? "Watch BGMI Masters Series Season 2 Live Streams, & Highlights, Scores, Schedule, Teams List, Player Stats, and more on Rooter." : "" }
				endpoint = { props?.currentPath }
				selectedGames = { selectedGames }
				seoTags = { seoTags }
				title = { isNodwin ? "BGMI Masters Series Season 2 Live Stream - BGMS 2023" : "" }
				userName = { name }
			/>

			<UserProfileNew
				activeTab = { activeTab }
				activeTabData = { activeTabData }
				broadcastDetails = { props?.broadcastDetails }
				profile = { props?.profile }
				ugcStats = { props?.ugcStats }
				userId = { userId }
			/>
		</Fragment>
	);
};

const userProfileParams = {
	follow         : true,
	isFollowing    : true,
	country        : true,
	stats          : true,
	block          : true,
	teams          : false,
	sports         : false,
	pendingRewards : false,
	access         : true,
	types          : true,
	followingGames : true,
	onboarding     : true
};

const getServerSideProps = async context => initialValidations ( context, async ( defaultProps, context ) => {

	let userId       = context.params.id;
	const data       = { userId };
	const activeTab  = context.query.tab || "live";
	const playRecent = context.query.play_recent;
	let error        = null;
	let profile      = null;

	// Calling profile api to handle user handles...userid can be number of string
	// if it is a string, we assume it is a user handle ...so need user id from profile in this case
	try {
		profile = await getUserProfile.bind ( defaultProps ) ( data, userProfileParams );
	} catch ( err ) {
		if ( err?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
			return {
				redirect: {
					destination : `/logout?forceLogout=${ true }&prevLocation=${ defaultProps?.currentPath }`,
					permanent   : false
				}
			};

		return { props: { ...defaultProps, error: err } };
	}

	userId         = profile.id;
	data["userId"] = userId;

	let seoTags, pageName = "profilePage";

	if ( playRecent ) {
		let params = {
			sportsFanId : userId,
			pageNo      : 1,
			pageSize    : 1
		};

		try {
			const response = await getUserSessions.bind ( defaultProps ) ( params );

			if ( !response || !response.length )
				throw "empty";

			return {
				redirect: {
					permanent   : false,
					destination : `/stream/${ response[0]?.id }`
				}
			};

		} catch ( err ) {
			// do nothing
		}
	}

	const results = await Promise.allSettled (
		[
			// getUserProfile.bind ( defaultProps ) ( data, userProfileParams ),
			getBroadcasterDetails.bind ( defaultProps ) ( data ),
			getUserProfileStats.bind ( defaultProps ) ( { userAuthDetails: data } ),
			fetchTabData.bind ( defaultProps ) ( { id: userId, tab: activeTab, pageNo: 1 } ),
			getSEOTags.bind ( defaultProps ) ( { pageName } )
		]
	);

	let broadcastDetails = null, ugcStats = null, activeTabData = [];
	let forceLogout      = false;

	results.forEach ( ( result, index ) => {
		if ( result.status === "fulfilled" ) {
			switch ( index ) {
				/* case 0:
         *     profile = result.value;
         *     break; */

				case 0:
					broadcastDetails = result.value;
					break;

				case 1:
					ugcStats = result.value;
					break;

				case 2:
					activeTabData = result.value;
					break;

				case 3:
					seoTags = result.value;
					break;

			}
		}

		if ( index === 0 && result.status === "rejected" && result.reason?.message !== "TOKEN_EXPIRED" )
			error = result.reason;

		if ( result.status === "rejected" && result.reason?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
			forceLogout = true;
	} );

	if ( forceLogout )
		return {
			redirect: {
				destination : `/logout?forceLogout=${ true }&prevLocation=${ defaultProps?.currentPath }`,
				permanent   : false
			}
		};

	if ( !defaultProps?.isLoggedIn && broadcastDetails && ugcStats )
		context.res.setHeader (
			"Cache-Control",
			"public, s-maxage=90, stale-while-revalidate=120"
		);

	return {
		props: {
			...defaultProps,
			error,
			profile,
			broadcastDetails,
			ugcStats,
			userId,
			activeTab,
			activeTabData,
			seoTags: seoTags?.seo_tags || []
		}
	};
} );

export { getServerSideProps };

export default component;
